import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/partner/configuration/filter'; // Importing Filter component
import Settings from 'views/partner/configuration/settings'; // Importing Settings component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * PartnerSettingsView class extends JetView to create a specific view for partner settings.
 */
export default class PartnerSettingsView extends JetView {
    /**
     * Configures the UI components of the PartnerSettingsView.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        const left = {
            Width: 250, // Width of the left panel
            responsiveCell: false, // Disable responsive behavior for the cell
            css: 'cajeros', // CSS class for styling
            rows: [
                // Array of UI components in the left panel
                {
                    view: 'toolbar', // Toolbar component
                    css: theme, // Apply the current theme
                    elements: [
                        // Elements within the toolbar
                        { view: 'label', label: _('Partner') }, // Label for the toolbar
                        {
                            type: 'wide', // Type of the element
                            css: 'close-bottom', // CSS class for styling
                            cols: [
                                // Array of columns in the element
                                {
                                    view: 'icon', // Icon component
                                    icon: 'wxi-close', // Icon type
                                    bottom: 20, // Bottom margin
                                    right: 35, // Right margin
                                    width: 30, // Width of the icon
                                    height: 30, // Height of the icon
                                    click: () => this.show('/top/dashboard'), // Click event to navigate to dashboard
                                },
                            ],
                        },
                    ],
                },
                Filter, // Including the Filter component
                Settings, // Including the Settings component
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        return {
            view: 'form', // Main view type
            type: 'wide', // Form type
            responsive: true, // Enable responsive behavior
            scroll: true, // Enable scrolling
            rows: [left], // Rows containing the left panel
        };
    }
}

// FILE DOCUMENTED
